// Custom traditional line-art hero backdrops (charcoal & gold on parchment).
const B = "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images";

export const HERO_ART = {
  home: `${B}/5546316281015d29e92c636fb2625e1f127fe6eb9af502880d9d3512f1adf51d.jpeg`,
  knowledge: `${B}/9bdbd66380dd4d52354d8283f06a31106f960ef055f30ef5779bcc2a6211d9a3.jpeg`,
  devotion: `${B}/a2752d7f7a95d8399cdcddbe47ae5e16a8047478ad5d8641091f40f6956b7356.jpeg`,
  cosmos: `${B}/859c50be9006d5313b6f9363019d3e97592bcbce8d9aafb363e0ec898bc04da3.jpeg`,
};

const TYPE_HERO = {
  katha: "knowledge", sukta: "knowledge", vedic: "cosmos",
  mantra: "devotion", stotra: "devotion", puja_vidhi: "devotion", festival: "devotion",
};
export const heroForType = (type) => HERO_ART[TYPE_HERO[type] || "knowledge"];

const SECTION_HERO = {
  scriptures: "knowledge", rishis: "knowledge", concepts: "knowledge", sanskrit: "knowledge",
  explainers: "knowledge", traditions: "devotion", pilgrimage: "devotion",
  samskara: "devotion", vrata: "devotion",
};
export const heroForSection = (section) => HERO_ART[SECTION_HERO[section] || "knowledge"];
